/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from "react";

export const useValidation = (formData: any) => {
    const [errorMessages, setErrorMessages] = useState<any>();

    {
        /** Validation */
    }

    const onInputChange = (alias: string) => {
        const result = errorMessages?.filter((x) => x.alias !== alias);
        setErrorMessages(result);
    };

    function validate(body: any) {
        const tmpErrorMessages = [];

        // Email validation regex
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        formData.allFields.forEach((field) => {
            let hasValue = undefined;

            // File upload
            if (
                body?.[field.alias] &&
                field.fieldTypeId === "08b8057f-06c9-6ca7-3a42-fd1fc2a46eff"
            ) {
                hasValue = body?.[field.alias]?.size > 0;
            }
            // Checkbox, Input, Radio etc.
            else {
                // Check if the value is a string before calling trim
                hasValue =
                    typeof body?.[field.alias] === "string"
                        ? body[field.alias].trim().length > 0
                        : Boolean(body?.[field.alias]);
            }

            // Required rule
            if (hasValue === false && field.mandatory) {
                tmpErrorMessages.push({
                    alias: field.alias,
                    message:
                        field.requiredErrorMessage ||
                        formData.requiredErrorMessage.replace("{0}", field.alias),
                });
            }

            // TODO: check if this is correct
            // Email validation
            if (field.alias === "eMail" || field.alias === "email") {
                const emailValue = body[field.alias];
                const isEmailInvalid = emailValue && !emailRegex.test(emailValue);
                const shouldValidateEmail =
                    field.mandatory || (emailValue && emailValue.trim().length > 0);

                if (shouldValidateEmail && isEmailInvalid) {
                    tmpErrorMessages.push({
                        alias: field.alias,
                        message:
                            field.requiredErrorMessage ||
                            formData.requiredErrorMessage.replace("{0}", field.alias),
                    });
                }
            }
        });

        setErrorMessages(tmpErrorMessages);

        return [tmpErrorMessages.length === 0, tmpErrorMessages];
    }

    //add Errors (Backend errors)
    function addErrors(errors?: any) {
        const tmpErrorMessages = [];

        if (!errors || typeof errors !== "object") {
            // If 'errors' is not an object or is null/undefined, return early.
            return;
        }

        for (const alias in errors) {
            if (Object.prototype.hasOwnProperty.call(errors, alias)) {
                const messages = errors[alias];

                // Check if 'messages' is an array
                if (Array.isArray(messages)) {
                    messages.forEach((message) => {
                        if (typeof message === "string") {
                            tmpErrorMessages.push({
                                alias: alias,
                                message: message,
                            });
                        }
                    });
                } else if (typeof messages === "string") {
                    // Handle the case where 'messages' is a single string
                    tmpErrorMessages.push({
                        alias: alias,
                        message: messages,
                    });
                }
                // Add more conditions here if there are other possible structures for 'messages'
            }
        }

        setErrorMessages(tmpErrorMessages);
    }

    function resetError(alias: string) {
        const tmpErrorMessages = errorMessages?.filter((x) => x.alias !== alias);
        setErrorMessages(tmpErrorMessages);
    }

    function getError(alias: string) {
        return errorMessages?.find((x) => x.alias === alias);
    }

    return {
        errorMessages,
        validate,
        getError,
        addErrors,
        onInputChange,
        resetError,
    };
};
